<template>
  <div :class="classList" :data-id="_uid">
    <div class="a-message__icon">
      <slot name="icon"></slot>
    </div>
    <div class="a-message__text">
      <slot name="text"></slot>
    </div>
    <div class="a-message__close" v-if="affixed" @click="closeButton">
      <icon name="times" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-message',
  props: {
    type: {
      type: [String],
      required: true,
    },
    subtype: [String],
    fullwidth: [Boolean],
    affixed: [Boolean],
    closeButton: {
      required: false,
      type: [Object, Function],
      default: () => {},
    },
  },
  computed: {
    classList() {
      const defaultClass = 'a-message is-raleway';
      const type = ` a-message--${this.type}`;
      const subtype = this.subtype ? ` a-message--${this.subtype}` : '';
      const fullwidth = this.fullwidth ? ' a-message--fullwidth' : '';
      const affixed = this.affixed ? ' a-message--affixed' : '';
      return defaultClass + type + subtype + fullwidth + affixed;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.a-message';

  $iconWidth: 52px;
  $iconWidthOutlined: 42px;

  #{$parent} {
    padding: $spacing-base;
    border: 1px solid;
    border-radius: 3px;
    color: #fff;
    position: relative;
    width: auto;
    display: inline-block;
    font-weight: 600;
    @include clearfix;
    svg {
      height: 14px;
      width: 14px;
      @include alignElement(true, true);
    }
    //elements
    &__icon {
      float: left;
      padding: $spacing-base + 1;
      margin: (-$spacing-base);
      line-height: 0;
      width: $iconWidth;
      @include alignElement(false, true);
      top: calc(50% + #{$spacing-base});
      height: 100%;
    }
    &__text {
      float: left;
      margin-left: 36px;
    }
    &__close {
      position: absolute;
      right: -8px;
      padding: 8px;
      top: -8px;
      border-radius: 30px;
      background: $color-error;
      border: 1px solid $color-error-dark;
      cursor: pointer;
      svg {
        padding: 2px;
      }
    }
    //modifiers
    &--fullwidth {
      width: 100%;
    }
    &--affixed {
      box-shadow: 0px 10px 3px -5px rgba(0, 0, 0, 0.15);
      z-index: 5000;
      top: auto;
      bottom: $spacing-base;
      left: $spacing-base;
      position: fixed;
    }
    &--info {
      background: $color-info;
      border-color: $color-info-dark;
    }
    &--success {
      background: $color-success;
      border-color: $color-success-dark;
    }
    &--warning {
      background: $color-warning;
      border-color: $color-warning-dark;
    }
    &--error {
      background: $color-error;
      border-color: $color-error-dark;
    }
    &--outlined {
      padding: $spacing-small;
      background: #fff;
      border-radius: 3px;
      #{$parent}__icon {
        width: $iconWidthOutlined;
        margin: -$spacing-small;
        top: calc(50% + #{$spacing-small});
        border-radius: 0;
        background: transparent;
        svg {
          width: 12px;
          height: 12px;
        }
      }
      #{$parent}__text {
        margin-left: $iconWidthOutlined - $spacing-small;
      }
      &#{$parent}--info #{$parent}__text,
      &#{$parent}--info #{$parent}__icon {
        color: $color-info;
      }
      &#{$parent}--success #{$parent}__text,
      &#{$parent}--success #{$parent}__icon {
        color: $color-success;
      }
      &#{$parent}--warning #{$parent}__text,
      &#{$parent}--warning #{$parent}__icon {
        color: $color-warning;
      }
      &#{$parent}--error #{$parent}__text,
      &#{$parent}--error #{$parent}__icon {
        color: $color-error;
      }
    }
    &--basic {
      padding: 0;
      background: transparent;
      border: 0;
      border-radius: 0;
      font-size: $font-size-small;
      #{$parent}__icon {
        background: transparent;
        svg {
          height: 16px;
          width: 16px;
        }
      }
      #{$parent}__text {
        margin-left: 0;
        padding-left: $spacing-large;
      }
      &#{$parent}--info #{$parent}__icon,
      &#{$parent}--info #{$parent}__text {
        color: $color-info;
      }
      &#{$parent}--success #{$parent}__icon,
      &#{$parent}--success #{$parent}__text {
        color: $color-success;
      }
      &#{$parent}--warning #{$parent}__icon,
      &#{$parent}--warning #{$parent}__text {
        color: $color-warning;
      }
      &#{$parent}--error #{$parent}__icon,
      &#{$parent}--error #{$parent}__text {
        color: $color-error;
      }
    }
  }
</style>
